import {
  Checkbox,
  Col,
  Dropdown,
  Menu,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Space,
  Tabs,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  TableItem,
  DatePickerItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem
} from "../../../../Components/Items";
import {
  CheckOutlined,
  DownOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import moment from "moment";
import "moment/locale/es";
import reporteDeEstadoDePosicionFinancieraPdf from "../../../../Pdf/reporteDeEstadoDePosicionFinancieraPdf";
import anexoAnalisisBalancePdf from "../../../../Pdf/anexoAnalisisBalancePdf";
import {
  opcionesPdfBalance,
  traeAnalisis,
  TIPO_PDF_BALANCE_DEFAULT,
  TIPOS_PDF_BALANCE,
} from "../../../../Pdf/balanceGeneralAnaliticas";
import {
  OPCIONES_EXCEL_BALANCE,
  descargarExcelBalance,
} from "./exportarEstadoDePosicionFinanciera";

moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

// Mismo realce que usa el menú de descargas de PreNómina para la opción de rutina.
const ESTILO_OPCION_DESTACADA = { fontWeight: 600, color: "#00BFD6" };

class ReporteEstadoDePosicionFinanciera extends Component {
  state = {
    loading: false,
    pdf: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoUniadesDeNegocio: null,
    todasUniadesDeNegocio: null,
    dataReporte: null,
    todasActivo: [],
    todasPasivo: [],
    todasCapital: [],
    ocultarDatosFiltrado: localStorage.getItem("ocultarDatosFiltradoPdf") === "true",
    // Ultima plantilla usada, para marcarla en el menu la proxima vez.
    tipoPdfBalance:
      TIPOS_PDF_BALANCE[localStorage.getItem("tipoPdfBalanceGeneral")]?.clave ||
      TIPO_PDF_BALANCE_DEFAULT,
    // Lo mismo para el Excel, que ofrece las tres variantes clasicas.
    tipoExcelBalance:
      OPCIONES_EXCEL_BALANCE.find(
        (tipo) => tipo.clave === localStorage.getItem("tipoExcelBalanceGeneral")
      )?.clave || TIPO_PDF_BALANCE_DEFAULT,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "unidadesdenegocio/selectUnidadesDeNegocio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasUniadesDeNegocio: res.data });
          this.setState({
            objetoUniadesDeNegocio: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                      value.nivel2 +
                      value.nivel3 +
                      value.nivel4 +
                      value.nivel5
                  ) +
                    " - " +
                    value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    this.consultarReporteEstadoDePosicionFinanciera(
        {
            fechaFinal: moment(),
            nivel: 3
        }
    );
  }

  consultarReporteEstadoDePosicionFinanciera(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesFinancieros/reporteEstadoDePosicionFinanciera",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasActivo: res.data.arrayActivo.map(valueCuenta => {
                return {
                    ...valueCuenta,
                    cuenta: cuentaMask(valueCuenta.nivel1+valueCuenta.nivel2+valueCuenta.nivel3+valueCuenta.nivel4+valueCuenta.nivel5)
                }
            }),
            todasPasivo: res.data.arrayPasivo.map(valueCuenta => {
                return {
                    ...valueCuenta,
                    cuenta: cuentaMask(valueCuenta.nivel1+valueCuenta.nivel2+valueCuenta.nivel3+valueCuenta.nivel4+valueCuenta.nivel5)
                }
            }),
            todasCapital: res.data.arrayCapital.map(valueCuenta => {
                return {
                    ...valueCuenta,
                    cuenta: cuentaMask(valueCuenta.nivel1+valueCuenta.nivel2+valueCuenta.nivel3+valueCuenta.nivel4+valueCuenta.nivel5)
                }
            }),
          });
        } else if (res.data.success === 1) {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        }
        this.setState({ loading: false });
      });
  }

  async descargarExcel(tipoExcelBalance) {
    localStorage.setItem("tipoExcelBalanceGeneral", tipoExcelBalance);
    this.setState({ tipoExcelBalance });
    try {
      await descargarExcelBalance(this.state.dataReporte, tipoExcelBalance);
    } catch (error) {
      console.error(error);
      message.error("No se pudo generar el Excel del reporte");
    }
  }

  descargarPdf(tipoPdfBalance) {
    localStorage.setItem("tipoPdfBalanceGeneral", tipoPdfBalance);
    this.setState({ tipoPdfBalance });

    const datos = {
      ...this.state.dataReporte,
      ocultarDatosFiltrado: this.state.ocultarDatosFiltrado,
      tipoPdfBalance,
    };
    const fecha = moment().locale("es").format("L");
    const balance = pdfMake.createPdf(
      reporteDeEstadoDePosicionFinancieraPdf(datos)
    );

    // Las plantillas "con analisis completo" bajan DOS archivos: el balance y su
    // anexo. La segunda descarga va en el callback de la primera y no en paralelo,
    // porque dos clics sinteticos seguidos hacen que el navegador pida permiso para
    // "descargas multiples" o se trague el segundo archivo.
    if (!traeAnalisis(tipoPdfBalance)) {
      balance.download(`Estado_de_Posicion_Financiera_${fecha}`);
      return;
    }
    balance.download(`Estado_de_Posicion_Financiera_${fecha}`, () => {
      pdfMake
        .createPdf(anexoAnalisisBalancePdf(datos))
        .download(`Anexo_Analisis_Balance_${fecha}`);
    });
  }

  cambiarOcultarDatosFiltrado(checked) {
    localStorage.setItem("ocultarDatosFiltradoPdf", String(checked));
    this.setState({ ocultarDatosFiltrado: checked });
  }

  /**
   * Opciones de un diseño. El check de ocultar filtrado vive en el título de un
   * Menu.ItemGroup y no en un Menu.Item a propósito: los títulos de grupo no son
   * elementos clicables del menú, así que marcarlo NO cierra el desplegable (que es
   * lo que pasaría con un Menu.Item, porque Dropdown cierra en cada clic de item).
   */
  opcionesMenuPdf(moderno) {
    return opcionesPdfBalance(moderno).map((tipo, indice) => (
      <Menu.Item
        key={tipo.clave}
        icon={
          this.state.tipoPdfBalance === tipo.clave ? (
            <CheckOutlined style={{ color: "#00BFD6" }} />
          ) : null
        }
        onClick={() => this.descargarPdf(tipo.clave)}
      >
        <div style={{ lineHeight: 1.25, padding: "2px 0" }}>
          <div style={indice === 0 ? ESTILO_OPCION_DESTACADA : undefined}>
            {tipo.etiquetaCorta}
          </div>
          <div style={{ fontSize: 11, color: "#888" }}>{tipo.descripcion}</div>
        </div>
      </Menu.Item>
    ));
  }

  /** Las tres variantes del Excel, con el mismo render que las del PDF. */
  opcionesMenuExcel() {
    return OPCIONES_EXCEL_BALANCE.map((tipo, indice) => (
      <Menu.Item
        key={tipo.clave}
        icon={
          this.state.tipoExcelBalance === tipo.clave ? (
            <CheckOutlined style={{ color: "#00BFD6" }} />
          ) : null
        }
        onClick={() => this.descargarExcel(tipo.clave)}
      >
        <div style={{ lineHeight: 1.25, padding: "2px 0" }}>
          <div style={indice === 0 ? ESTILO_OPCION_DESTACADA : undefined}>
            {tipo.etiquetaCorta}
          </div>
          <div style={{ fontSize: 11, color: "#888" }}>{tipo.descripcion}</div>
        </div>
      </Menu.Item>
    ));
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const columns = [
      {
        title: "Cuenta",
        dataIndex: "cuenta",
        key: "cuenta",
        sorter: (a, b) => {
          if (a.cuenta < b.cuenta) {
            return -1;
          }
          if (a.cuenta > b.cuenta) {
            return 1;
          }
          return 0;
        },
        buscar: "cuenta",
        ellipsis: true,
      },
      {
        title: "Descripcion",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: (a, b) => {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        },
        buscar: "descripcion",
        ellipsis: true,
      },
      {
        title: "Importe",
        dataIndex: "saldo",
        key: "saldo",
        sorter: (a, b) => {
          if (a.saldo < b.saldo) {
            return -1;
          }
          if (a.saldo > b.saldo) {
            return 1;
          }
          return 0;
        },
        buscar: "saldo",
        render: (value) => dineroDisabledMask(value),
        align: 'right',
        ellipsis: true,
      },
    ];

    const menuPdf = (
      <Menu selectable={false} style={{ minWidth: 300 }}>
        {/* Va como título de grupo y no como Menu.Item para que marcarlo no cierre
            el desplegable: los títulos de grupo no son elementos clicables. */}
        <Menu.ItemGroup
          title={
            <Checkbox
              checked={this.state.ocultarDatosFiltrado}
              onChange={(e) =>
                this.cambiarOcultarDatosFiltrado(e.target.checked)
              }
            >
              Ocultar datos de filtrado
            </Checkbox>
          }
        />
        <Menu.Divider />
        <Menu.SubMenu
          key="disenoClasico"
          icon={<FilePdfOutlined />}
          title="Diseño Clásico"
        >
          {this.opcionesMenuPdf(false)}
        </Menu.SubMenu>
        <Menu.SubMenu
          key="disenoModerno"
          icon={<FilePdfOutlined />}
          title="Diseño Moderno"
        >
          {this.opcionesMenuPdf(true)}
        </Menu.SubMenu>
      </Menu>
    );

    return (
      <>
        <Form
          ref={this.formRef}
          name="rerpoteEstadoDePosicionFinanciera"
          onFinish={this.consultarReporteEstadoDePosicionFinanciera.bind(this)}
          onFinishFailed={this.onFinishFailed}
            inita
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Estado de Posicion Financiera"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <Dropdown
                      trigger={["click"]}
                      overlay={
                        <Menu selectable={false} style={{ minWidth: 300 }}>
                          {this.opcionesMenuExcel()}
                        </Menu>
                      }
                    >
                      {/* lessTime: igual que el disparador del PDF, para poder
                          reabrir el menú sin esperar el auto-bloqueo de 1s. */}
                      <ButtonItem
                        blanco
                        lessTime
                        icon={<FileExcelOutlined />}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        Descargar Excel <DownOutlined />
                      </ButtonItem>
                    </Dropdown>
                  )}
                  {this.state.dataReporte && (
                    <Dropdown trigger={["click"]} overlay={menuPdf}>
                      {/* lessTime: ButtonItem se auto-bloquea 1s al hacer clic aunque
                          no lleve onClick, y eso impediría reabrir el menú. */}
                      <ButtonItem
                        blanco
                        lessTime
                        icon={<FilePdfOutlined />}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        Descargar PDF <DownOutlined />
                      </ButtonItem>
                    </Dropdown>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                      Filtros:
                    </h1>
                  ),
                }}
              >
                <TabPane tabKey="3" key="3" forceRender tab="Fecha Final">
                  <FormItem marginBottom='0px' initialValue={moment()} label="Fecha Final" name="fechaFinal" required>
                    <DatePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem
                        name="filtrarProyecto"
                        required
                        noStyle
                        initialValue={0}
                      >
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>
                            Niguno
                          </Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto =
                            getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) {
                            return (
                              <FormItem
                                required
                                name="proyectos"
                                noStyle
                              >
                                <SelectItem
                                  width="90%"
                                  placeholder="Proyectos"
                                  mode="multiple"
                                >
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          if (filtrarProyecto === 2) {
                            return (
                              <FormItem
                                required
                                name="unidadDeNegocioId"
                                noStyle
                              >
                                <SelectItem
                                  width="90%"
                                  placeholder="Unidades de Negocio"
                                >
                                  {this.state.objetoUniadesDeNegocio}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="5" key="5" forceRender tab="Nivel">
                  <FormItem
                    label="Nivel"
                    name="nivel"
                    required
                    marginBottom='0px'
                    initialValue={3}
                  >
                    <SelectItem placeholder="Nivel">
                      <Option value={1}>Nivel 1</Option>
                      <Option value={2}>Nivel 2</Option>
                      <Option value={3}>Nivel 3</Option>
                      <Option value={4}>Nivel 4</Option>
                      <Option value={5}>Nivel 5</Option>
                    </SelectItem>
                  </FormItem>
                </TabPane>
              </Tabs>
            </div>
            <Row gutter={[16, 16]}>
                <Col span={12}>
                    <h1 style={{textAlign: 'center'}}>Activo</h1>
                <TableItem
                    columns={columns}
                    dataSource={this.state.todasActivo}
                    size="small"
                    pagination={false}
                    />
                </Col>
                <Col span={12}>
                <h1 style={{textAlign: 'center'}}>Pasivo</h1>
                <TableItem
              columns={columns}
              dataSource={this.state.todasPasivo}
              size="small"
              pagination={false}
            />
            <h1 style={{textAlign: 'center'}}>Capital</h1>
                        <TableItem
              columns={columns}
              dataSource={this.state.todasCapital}
              size="small"
              pagination={false}
            />
                </Col>
            </Row>
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteEstadoDePosicionFinanciera);
